/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LookupListDto } from '../models/LookupListDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LookupsService {
    /**
     * API to get lookups
     * @param types
     * @returns LookupListDto OK
     * @throws ApiError
     */
    public static getApiLookups(
        types?: Array<string>,
    ): CancelablePromise<Array<LookupListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Lookups',
            query: {
                'Types': types,
            },
        });
    }
}
